export const TICK = 1;
export const DELAY = 2;
export const RESPONSE = 3;
export const STOP = 4;
export const BPM_CHANGED = 5;
export const TRANSFER_TRACK = 6;
